/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sfs": {
        "nested": {
          "external": {
            "nested": {
              "service": {
                "nested": {
                  "UnlockNotificationRequest": {
                    "fields": {
                      "customerId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "UnlockNotificationResponse": {
                    "fields": {
                      "errors": {
                        "type": ".squareup.connect.v2.resources.Error",
                        "id": 1,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.UnlockNotificationRequest && !$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.UnlockNotificationResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE UnlockNotificationRequest @ squareup/sfs/external/services/notification/unlock_notification.proto at 8:1
 */
export const UnlockNotificationRequest = $root.lookupType('squareup.sfs.external.service.UnlockNotificationRequest');
fixType(UnlockNotificationRequest, {
  customerId: {
    required: true
  }
});
Builder.createAndAttachToType(UnlockNotificationRequest);
/**
 * SOURCE UnlockNotificationResponse @ squareup/sfs/external/services/notification/unlock_notification.proto at 15:1
 */
export const UnlockNotificationResponse = $root.lookupType('squareup.sfs.external.service.UnlockNotificationResponse');
fixType(UnlockNotificationResponse);
Builder.createAndAttachToType(UnlockNotificationResponse);